import { getEnv } from 'shared/config/constants';

export const getDdRumConfig = () => ({
  applicationId: '13bbccac-602c-45aa-afab-2003c579fdd6',
  clientToken: 'pube7ff1b4d4673fd9dd81fe8d98cb76fa8',
  site: 'datadoghq.com',
  service: 'educator-home',
  sampleRate: 100,
  version: 'b41780e22fe58f358f7c19eb7f9471c437a7f002',
  trackInteractions: false,
  env: getEnv(),
});
